import { setCurrentTip, WeekViewCurrentTip } from "@actions/week-view.actions";
import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";
import { TutorialTip } from "@clockwise/web-commons/src/components/tutorial-tip";
import { IReduxState } from "@reducers/root.reducer";
import { getCurrentEnvironment } from "@src/state/relay-environment";
import { getNextWeekViewTip, updateWeekViewFlags } from "@src/util/flags.util";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as ISchema from "@schema";

export const TUTORIAL_TOOLTIP_HEADER_CLASSES = "cw-font-brand cw-text-base cw-font-bold cw-mb-2";
export const TUTORIAL_TOOLTIP_BODY_CLASSES = "cw-font-body cw-text-sm";

const TutorialSetMeetingFlexibility = ({
  userWebAppFlags,
}: {
  userWebAppFlags: ISchema.FlagsErrorable;
}) => {
  const t = React.useContext(TranslationContext);
  const environment = getCurrentEnvironment();
  const dispatch = useDispatch();

  const mode = useSelector((state: IReduxState) => state.webExtension.mode);
  const contentScrollTop = useSelector((state: IReduxState) => state.webExtension.contentScrollTop);
  const currentTip = useSelector((state: IReduxState) => state.weekView.currentTip);

  if (currentTip !== WeekViewCurrentTip.AutopilotSettings || mode !== "webapp") {
    return null;
  }

  const verticalOffset = 0 - contentScrollTop;

  return (
    <TutorialTip
      containerStyle={{
        zIndex: 4,
        transform: `translate(calc(-100% - 15px), ${verticalOffset}px)`,
      }}
      tipColor="white"
      hide={false}
      onDismiss={() =>
        updateWeekViewFlags(environment, currentTip).finally(() =>
          dispatch(setCurrentTip(getNextWeekViewTip(userWebAppFlags, currentTip))),
        )
      }
      dismissText="Got it"
      tipPosition="right"
      tooltipContents={
        <React.Fragment>
          <div className={TUTORIAL_TOOLTIP_HEADER_CLASSES}>
            {t("autopilot-form:tutorial-title")}
          </div>
          <div className={TUTORIAL_TOOLTIP_BODY_CLASSES}>{t("autopilot-form:tutorial-body")}</div>
        </React.Fragment>
      }
    />
  );
};

export default TutorialSetMeetingFlexibility;
